<template>
    <div class="text-center">
        <p v-if="isNaN(Total)" class="mb-0 h5 font-weight-bold text-dark">Total Payable: <b-spinner class="mb-2" small label="Medium Spinner"></b-spinner> </p>
        <p v-else class="mb-0 h5 font-weight-bold text-dark">Total Payable: {{'$' + Total.toFixed(2)}}</p>
        <p class="mb-0 mt-4">Please collect cash from customer to proceed.</p>
        <p class="mb-0 mt-3">
            Cash drawer, if available, will open after you admit cash collection.
        </p>
        <div class="m-2" v-if="cashOnly">
            <b-alert :show="amount < Total && amount != '' " variant="danger" class="px-4 my-2">
                        The Collected Cash Amount must be {{ Total }} or more
            </b-alert>
            <b-alert :show="amount === ''" variant="danger" class="px-4 my-2">
                        
            </b-alert>
            <b-input-group class="px-4" :prepend="'Collected Cash Amount ($)'">
                <b-input type="number" v-model="amount" no-seprator :name="'Collected Cash Amount'" v-validate="`required|min_value:${getTotal}`"/>
            </b-input-group>
            <div v-if="payBackMoney > 0" class="m-4 text-center text-danger font-weight-bold" :style="{'font-size':'large'}">Change to Give Back to Customer: ${{payBackMoney}}</div>
            <div class="d-flex flex-row justify-content-center m-3" :style="{'gap':'1rem'}">
                    <b-button variant="success" size="lg" @click="billButton(1)" :disabled="isNaN(Total)">
                        $1
                    </b-button>
                    <b-button variant="success" size="lg" @click="billButton(5)" :disabled="isNaN(Total)">
                        $5
                    </b-button>
                    <b-button variant="success" size="lg" @click="billButton(10)" :disabled="isNaN(Total)" >
                        $10
                    </b-button>
                    <b-button variant="success" size="lg" @click="billButton(20)"  :disabled="isNaN(Total)">
                        $20
                    </b-button>
                    <b-button variant="success" size="lg" @click="billButton(50)"  :disabled="isNaN(Total)">
                        $50
                    </b-button>
                    <b-button variant="success" size="lg" @click="billButton(100)" :disabled="isNaN(Total)" >
                        $100
                    </b-button>
                    <b-button class="ml4" variant="danger" size="lg" @click="clearAmmount()" :disabled="isNaN(Total)" >
                        Clear
                    </b-button>
                    
                </div>
        </div>
        <div class="m-4 ">
            <b-btn v-if="cashOnly" :disabled="disabledCashOnlyAdmit" style="height: 3rem; font-size: 1.3rem;" variant="warning" class="font-weight-bold px-4" @click="goFinalCashOnly">Admit Cash Collection</b-btn>
            <b-btn v-else :disabled="isNaN(Total)" style="height: 3rem; font-size: 1.3rem;" variant="warning" class="font-weight-bold px-4" @click="openCashForm">Admit Cash Collection</b-btn>
            <b-btn style="height: 3rem; font-size: 1.3rem;" variant="warning" class="ml-4 font-weight-bold px-4 mx-2" @click="cancelConfirmation">
                <span v-if="loading">
                    <b-spinner small type="border" class="mr-2"></b-spinner>
                    Loading...
                </span>
                <span v-else>
                    Never mind
                </span>
            </b-btn>
        </div>
        <c-modal
            size="md"
            v-model="cashForm"
            centered
            :tag="false"
            title="Confirmation"
            cancel-label="Cancel & Never mind"
            confirm-label="Confirm to Proceed"
            body-class="p-3 text-center"
            @submit="goFinal"
        >
            <template>
                <div>
                    <b-alert :show="errors.any()" variant="danger" class="px-4 my-2">
                        <ul class="m-0 px-1">
                            <li v-for="err in errors.all()" :key="err">{{err}}</li>
                        </ul>
                    </b-alert>
                </div>
                <div class="mb-2">Your confirmation will change tab pay status from "Unpaid" to "Cash Paid", and pay status cannot be reverted then.</div>
                <div class="mb-4">Your confirmation will open cash drawer, if available, only once.</div>
                <div class="mb-3">
                    <b-input-group :prepend="'Collected Cash Amount ($)'">
                        <b-input type="number" v-model="amount" no-seprator :name="'Collected Cash Amount'" v-validate="`required|min_value:${getTotal}`"/>
                    </b-input-group>
                </div>
                
            </template>
        </c-modal>


        <c-modal
            v-model="confirmForm"
            centered
            hide-header
            :tag="false"
            size="md"
            confirm-label="Print Customer Receipt & close"
            cancel-label="Close"
            @submit="printReceipt"
            @hide="closeAllPopUp"
            >
            <template>
                <div class="mb-3 text-center">Tab {{tabNo}} <span v-if="tableNo"> - {{tableNo}}</span> status changed to Cash Paid.</div>
                <div class="mb-4 text-center">Change to Give Back to Customer: ${{payBackMoney}}</div>
            </template>
        </c-modal>


    </div>
</template>

<script>
    import NumericInput from "./NumericInput";
    import CModal from "./Cmodal";
    export default {
        name: "cashPay",
        components: {CModal, NumericInput},
        props: {
            Total: {required: true},
            tabNo: {required: true},
            tableNo: {required: true},
            HasActiveReceiptPrinter: {required: false},
            HasActiveTicketPrinter: {required: false},
            cashOnly:{required: false,default: false},//if called from payment operations don't show the popups, to reduce the number of popups during ordering
        },
        data () {
            return {
                cashForm: false,
                confirmForm: false,
                amount: null
            }
        },
        computed: {
            disabledCashOnlyAdmit(){
                if(isNaN(this.Total)){
                    return true
                }
                if(this.amount < this.Total && this.amount != ''){
                    return true
                }
                return false
            },
            disablePrintButton () {
                return this.HasActiveReceiptPrinter || this.HasActiveTicketPrinter
            },
            proceedStatus () {
                return !!this.amount
            },
            getTotal () {
                return this.Total && +this.Total.toFixed(2)
            },
            payBackMoney () {
                return (+this.amount - +this.Total.toFixed(2)).toFixed(2)
            }
        },
        
        watch: {
            'Total': {
                handler: function (newVal) {
                    if (!isNaN(newVal) && this.cashOnly) {   
                        
                        this.amount = this.getTotal
                        
                    }
                },
            }
        },
        methods: {
            clearAmmount(){
                this.amount = 0
            },
            billButton(bill){
                // Round the total to 2 decimal places for comparison
                const roundedTotal = Math.round(this.Total * 100) / 100;
                const roundedAmount = Math.round(this.amount * 100) / 100;
                if (roundedAmount === roundedTotal) {
                    this.amount = 0
                }
                this.amount += bill
            },
            preventTypeString (evt) {
                if (evt.which != 8 && evt.which != 0 && evt.which < 48 || evt.which > 57){
                    evt.preventDefault();
                }
            },
            goFinal () {
              this.$validator.validateAll().then(res => {
                  if (res) {
                      this.confirmForm = true
                      this.cashForm = false
                      this.$emit('OpenBox')
                  }
              })
            },
            goFinalCashOnly () {
              this.loading = true
              this.$validator.validateAll().then(res => {
                  if (res) {
                    
                    this.$emit("setCashReturnAmmount",this.payBackMoney)
                      this.cashForm = false
                      this.$emit('OpenBox')
                      this.closeAllPopUp()
                      this.loading = false
                  }
              })
            },
            printReceipt () {
                this.confirmForm = false
                this.cashForm = false
                this.$emit('printReceipt')
            },
            closeAllPopUp () {
                this.confirmForm = false
                this.cashForm = false
                this.$emit('closeAllPopUp')
            },
            cancelConfirmation () {
                this.$emit('cancelConfirmation')
            },
            openCashForm () {
                if(this.cashOnly){
                   
                    return
                }
                this.cashForm = true
                this.amount = this.getTotal
            }
        }
    }
</script>

<style scoped>

</style>
